import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Table } from "../";

import { formatDate, formatCurrency } from "../../utils/helpers";

const columns = [
  {
    Header: "Waybill no",
    accessor: "id",
  },
  {
    Header: "Staff",
    accessor: "staff",
  },
  {
    Header: "Receiver phone",
    accessor: "receiverPhoneNumber",
  },
  {
    Header: "Receiver name",
    accessor: "receiverName",
  },
  {
    Header: "Origin Hub",

    Cell: ({ cell }) => {
      const d = cell?.row?.original;
      return `${d?.originHub?.name} `;
    },
  },
  {
    Header: "Destination Hub",
    Cell: ({ cell }) => {
      const d = cell?.row?.original;
      return `${d?.destinationHub?.name} `;
    },
  },
  {
    Header: "Status",
    accessor: "orderStatusId",
  },
  {
    Header: "Created",
    accessor: "createdAt",
  },
];

const formatData = (data, isCol) => {
  const res = data
    ? data.map((d) => ({
        ...d,
        createdAt: isCol ? formatDate(d.dateCreated) : formatDate(d.createdAt),
        amount: isCol
          ? formatCurrency(d.totalAmount)
          : `${formatCurrency(d.amount)}`,
        receiverName: `${d.receiverFirstName} ${d.receiverLastName}`,
        receiverPhoneNumber: `+${d.receiverPhoneNumber}`,
        ...(isCol
          ? {}
          : {
              staff: d.staff
                ? `${d?.staff?.aspNetUser?.firstName} ${d?.staff?.aspNetUser?.lastName}`
                : "-",
            }),
      }))
    : [];
  return res;
};

const OrdersTable = ({ data }) => {
  const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = useState("all");

  const goTo = (row) => {
    navigate(`/dashboard/your-orders/${row.id}`);
  };
  const formattedData = useMemo(() => formatData(data), [data]);

  const filteredData = useMemo(() => {
    if (statusFilter === "all") return formattedData;
    return formattedData.filter(
      (data) => String(data.orderStatusId) === String(statusFilter)
    );
  }, [formattedData, statusFilter]);

  return (
    <div>
      <div className="mb-4 flex gap-2 items-center">
        <label htmlFor="statusFilter">Filter by Status:</label>
        <select
          id="statusFilter"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="border p-2 rounded"
        >
          <option value="all">All</option>
          <option value="booked">Booked</option>
          <option value="InTransit">InTransit</option>
          <option value="delivered">delivered</option>
          <option value="picked">Picked</option>{" "}
          <option value="confirmed">Confirmed</option>{" "}
          <option value="cancelled">Cancelled</option>{" "}
          <option value="dropoff">Dropoff</option>{" "}
          <option value="breakdown">Breakdown</option>
          <option value="awaitingreview">Awaiting Review</option>{" "}
          <option value="warehouse">Warehouse</option>
          <option value="rideraccepted">Rider Accepted</option>{" "}
          <option value="localpickup">Local Pickup</option>
          <option value="awaitingreview">Awaiting Review</option>{" "}
          <option value="unassigned">Unassigned</option>
          <option value="missing">Missing</option>{" "}
          <option value="Transshipped">Trans shipped</option>
        </select>
      </div>
      <Table
        data={filteredData}
        paginate
        bordered
        columns={columns}
        fieldForTotal="amt"
        rowClickHandler={goTo}
      />
    </div>
  );
};

const cols = [
  {
    Header: "Waybill no",
    accessor: "orderId",
  },
  {
    Header: "Receiver phone",
    accessor: "receiverPhoneNumber",
  },
  {
    Header: "Receiver name",
    accessor: "receiverName",
  },
  {
    Header: "Origin Hub",
    accessor: "departureHubName",
  },
  {
    Header: "Destination Hub",
    accessor: "destinationHubName",
  },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Created",
    accessor: "createdAt",
  },
];

const CollectionsTable = ({ data }) => {
  const navigate = useNavigate();

  const goTo = (row) => {
    navigate(`/dashboard/your-orders/${row.orderId}?fromCol=true`);
  };

  return (
    <div>
      <Table
        data={formatData(data, true)}
        paginate
        bordered
        columns={cols}
        fieldForTotal="amt"
        rowClickHandler={goTo}
      />
    </div>
  );
};

export { OrdersTable, CollectionsTable };
